import { atom } from 'jotai'
import { atomWithStorage, createJSONStorage } from 'jotai/utils'

export const atomWithLocalStorage = <Value>(
  key: string,
  initialValue: Value
) => {
  // user can disable localStorage in browser settings
  try {
    // eslint-disable-next-line no-unused-expressions
    window.localStorage

    return atomWithStorage<Value>(key, initialValue, {
      ...createJSONStorage(() => localStorage),
      delayInit: false,
    })
  } catch {
    return atom<Value>(initialValue)
  }
}
